var loadMoreButton = document.getElementById('popular-safaris-load-more');
var camps = document.getElementsByClassName('safari-card');
var x = 3;
var y = 4;
var z = 5;

if (loadMoreButton) {
    loadMoreButton.addEventListener('click', function(event) {
        event.preventDefault();
        newCount(x,y,z);
    
        x = x + 3;
        y = y + 3;
        z = z + 3;    
        
        if (x == camps.length || y == camps.length || z == camps.length) {
            console.log('here');
            if (camps.length % 3 == 0) {
                console.log('there');
                removeButtonCatch(x, y, z);
            }
        }
    })
}

function newCount(x,y,z) {
    for (var i = 0; i < camps.length; i++) {

        if (x + 1 > camps.length) {
            x = '';
        }
        if (y + 1 > camps.length) {
            y = '';
        }
        if (z + 1 > camps.length) {
            z = '';
        }
    }

    updateClasses(x, y, z);
}

function updateClasses(x, y, z) {
    if (x !== '') {
        camps[x].classList.remove('safari-card--disabled');
    } 
    if (y !== '') {
        camps[y].classList.remove('safari-card--disabled');
    } 
    if (z !== '') {
        camps[z].classList.remove('safari-card--disabled');
    }

    if (x == '' || y == '' || z == '') {
        loadMoreButton.style.display = 'none';
    }
}

function removeButtonCatch(x,y,z) {
        loadMoreButton.style.display = 'none';
}